import styled from 'styled-components';
import { Button as AlchemyButton } from '@m/alchemy-ui/Button';
import { LoadingIndicator } from '@m/alchemy-ui/LoadingIndicator';
import { Grid } from '@m/alchemy-ui/Grid';
import { typeStyle, units } from '@m/alchemy-ui/theme';

export const HelpText = styled.p`
  margin: 0 auto;
  max-width: 650px;
  text-align: center;
`;

export const Loading = styled(LoadingIndicator)`
  display: block;
  margin: 48px 0;
  text-align: center;
`;

export const GridWithMargin = styled(Grid)`
  margin: ${units(3)} 0;
`;

export const Note = styled.p`
  ${typeStyle('captionM')};
  text-align: center;
`;

export const Button = styled(AlchemyButton)`
  padding: 0 ${units(4)};
`;

export const Footer = styled.div`
  margin-top: ${units(3)};
  text-align: right;

  ${Button} + ${Button} {
    margin-left: ${units(1)};
  }
`;
